import { Component, effect, ElementRef, input, output, signal, viewChild } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormsModule } from '@angular/forms';
import { filter, tap } from 'rxjs';
import { SearchQuery } from '../model/document-searcher.interface';
import { Keys, onKeyPressCapture } from '@ps-gui/shared-core';

@Component({
  selector: 'shared-dp-document-search-popover',
  templateUrl: 'document-search-popover.component.html',
  imports: [FormsModule],
})
export class DocumentSearchPopoverComponent {
  private readonly _isOpen = signal(false);
  readonly isOpen = this._isOpen.asReadonly();

  readonly searchString = signal('');
  readonly similarityThreshold = signal(1);

  private readonly searchInputElement = viewChild<ElementRef<HTMLInputElement>>('searchInput');

  readonly foundWordsCount = input.required<number | undefined>();

  readonly searchQueried = output<SearchQuery>();
  readonly searchClear = output();

  constructor() {
    this.initKeyEvents();

    effect(() => {
      const isOpen = this.isOpen();
      const input = this.searchInputElement();
      if (isOpen && input) {
        input.nativeElement.focus();
      }

      if (!isOpen) {
        this.searchString.set('');
        this.searchClear.emit();
      }
    });
  }

  private initKeyEvents() {
    Keys.Escape.down.pipe(takeUntilDestroyed()).subscribe(() => this._isOpen.set(false));
    onKeyPressCapture('Enter')
      .pipe(
        filter(() => this.isOpen()),
        tap((event) => event.stopPropagation()),
        takeUntilDestroyed(),
      )
      .subscribe(() =>
        this.searchQueried.emit({
          searchString: this.searchString(),
          similarityThreshold: this.similarityThreshold(),
        }),
      );
  }

  toggle() {
    this._isOpen.update((isOpen) => !isOpen);
  }
}
